import React, { useState } from "react";
import { Formik, Field, Form as FormikForm } from "formik";
import * as Yup from "yup";
import Image from "react-bootstrap/Image";
import { Button, Form } from "react-bootstrap";
import CustomForm from "../../../components/customcomponents/CustomForm";
import { Link } from "react-router-dom";
import { IMAGES } from "../../../assets/images/images";
import { Icon } from "@iconify/react";
import { registerHost } from "../../../utility/apiServices/userServices";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import {
  UseridState,
  emailState,
} from "../../../utility/globle/recoil/atom";
import { phoneRegExp } from "../../../utility/local/constants";
import GoogleLoginButton from "../../userpanel/userauth/auth/GoogleLoginButton";
import { useTranslation } from "react-i18next";
const PropertyOwnerSignUp = () => {
  const { t } = useTranslation();
  const setId = useSetRecoilState(UseridState);
  const setEmail = useSetRecoilState(emailState);
  const navigate = useNavigate();
  const [Loading, setLoading] = useState(false);
  const initialValues = {
    name: "",
    email: "",
    phoneNumber: "",
    password: "",
    idNumber: "",
    role: "host",
    account_type: "host",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().min(3).required(t("ownersignup.error_name_required")),
    email: Yup.string()
      .email(t("ownersignup.error_invalid_email"))
      .required(t("ownersignup.error_email_required")),
    phoneNumber: Yup.string()
      .min(10)
      .max(20)
      .required(t("ownersignup.error_phone_required"))
      .matches(phoneRegExp, t("ownersignup.error_phone_invalid")),
    password: Yup.string()
      .min(8)
      .required(t("ownersignup.error_password_required")),
    idNumber: Yup.string()
      .min(8)
      .required(t("ownersignup.error_id_required")),
  });

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      let response = await registerHost({
        email: values.email,
        name: values.name,
        phone_number: values.phoneNumber,
        password: values.password,
        status: "active",
        user_role: "host",
        account_type: "host",
        id_number: values.idNumber,
      });

      if (response.status) {
        setLoading(false);
        setId(response?.data?.id);
        setEmail(response?.data?.email);
        navigate("/verify-otp");
      } else {
        setLoading(false);
        Swal.fire({
          icon: "error",
          text: response?.message || "User is already registered!",
        });
      }
    } catch (err) {
      console.log("error in handleSubmit", err);
    }
  };

  return (
    <section className="login_box">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-md-6 hideloginimg">
            <div className="login_bg">
              <Image src={IMAGES.Login_Bg} className="img-fluid" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="loginBody">
              <h1>{t("ownersignup.create_account")}</h1>
              <p className="para">
                {t("ownersignup.description")}
              </p>

              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                validateOnChange
                validateOnBlur
              >
                {({ errors, touched }) => (
                  <FormikForm>
                    <Form.Group className={"mb-3"}>
                      <Field name="name">
                        {({ field }) => (
                          <CustomForm
                            color={"#222528"}
                            controlText="name"
                            type="text"
                            lableText={t("ownersignup.name")}
                            placeholderText={t("ownersignup.enter_name")}
                            {...field}
                          />
                        )}
                      </Field>
                      {touched.name && errors.name && (
                        <div className="errorStyle">{errors.name}</div>
                      )}
                    </Form.Group>

                    <Form.Group className={"mb-3"}>
                      <Field name="email">
                        {({ field }) => (
                          <CustomForm
                            color={"#222528"}
                            controlText="email"
                            type="email"
                            lableText={t("ownersignup.email")}
                            placeholderText={t("ownersignup.enter_email")}
                            {...field}
                          />
                        )}
                      </Field>
                      {touched.email && errors.email && (
                        <div className="errorStyle">{errors.email}</div>
                      )}
                    </Form.Group>

                    <Form.Group className={"mb-3"}>
                      <Field name="phoneNumber">
                        {({ field }) => (
                          <CustomForm
                            color={"#222528"}
                            controlText="phoneNumber"
                            type="text"
                            lableText={t("ownersignup.phone_number")}
                            placeholderText={t("ownersignup.enter_phone")}
                            {...field}
                          />
                        )}
                      </Field>
                      {touched.phoneNumber && errors.phoneNumber && (
                        <div className="errorStyle">{errors.phoneNumber}</div>
                      )}
                    </Form.Group>

                    <Form.Group className={"mb-3"}>
                      <Field name="password">
                        {({ field }) => (
                          <CustomForm
                            color={"#222528"}
                            controlText="password"
                            type="password"
                            lableText={t("ownersignup.password")}
                            placeholderText={t("ownersignup.enter_password")}
                            {...field}
                          />
                        )}
                      </Field>
                      {touched.password && errors.password && (
                        <div className="errorStyle">{errors.password}</div>
                      )}
                    </Form.Group>

                    <Form.Group className={"mb-3"}>
                      <Field name="idNumber">
                        {({ field }) => (
                          <CustomForm
                            color={"#222528"}
                            controlText="idNumber"
                            type="text"
                            lableText={t("ownersignup.id_number")}
                            placeholderText={t("ownersignup.enter_id")}
                            {...field}
                          />
                        )}
                      </Field>
                      {touched.idNumber && errors.idNumber && (
                        <div className="errorStyle">{errors.idNumber}</div>
                      )}
                    </Form.Group>

                    <Button
                      type="submit"
                      className="btn btn-primary my-3 mb-4 my-mb-3 mb-md-3 my-lg-3 w-100"
                      disabled={Loading}
                    >
    {Loading ? <span className="spinner"></span> : t("ownersignup.sign_up")}
                    </Button>
                  </FormikForm>
                )}
              </Formik>

              <p className="text-center">
                {t("ownersignup.already_have_account")}{" "}
                <Link
                  to="/login"
                  className="forgotPassword forgotPassword1"
                >
                  {t("ownersignup.login")}
                </Link>
              </p>

              <div className="orBox">
                <span>{t("ownersignup.or")}</span>
              </div>

              <div className="loginSocial">
                <Link>
                  <Icon icon="logos:facebook" fontSize={24} />
                </Link>
                <GoogleLoginButton
                  data={{
                    is_influencer: true,
                    account_type: "host"
                  }}

                />
                <Link>
                  <Icon
                    icon="ic:baseline-apple"
                    color="#000000"
                    fontSize={30}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PropertyOwnerSignUp;
